exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".panel--3EvKr{display:flex;flex-direction:column;gap:24px;padding-top:70px;width:240px;flex-shrink:0}.copy--25QjB{font-size:12px;line-height:16px;color:#000}.awardsWrap--4NarP{flex-direction:column;width:100%}.awardRow--eRzF6,.awardsWrap--4NarP{display:flex;gap:12px;align-items:center}.awardRow--eRzF6{width:200px}.awardLogo--1m2Y3{width:25px;height:57px;-o-object-fit:contain;object-fit:contain;flex-shrink:0}.awardTitle--eSAxU{color:#0070d3;font-size:12px;font-weight:700;text-transform:uppercase}.awardSubtitle--1GrCG{font-size:10px;color:#000;line-height:1.4}", ""]);

// Exports
exports.locals = {
	"panel": "panel--3EvKr",
	"copy": "copy--25QjB",
	"awardsWrap": "awardsWrap--4NarP",
	"awardRow": "awardRow--eRzF6",
	"awardLogo": "awardLogo--1m2Y3",
	"awardTitle": "awardTitle--eSAxU",
	"awardSubtitle": "awardSubtitle--1GrCG"
};